import React from 'react'
import classes from './index.module.scss';
import { IconButton } from '@material-ui/core';
import RonadIcons from '../../../../components/iconComponent';

const SearchBox = (props: any) => {
  return (
    <div className={classes.searchBox} >
      <input className={classes.input} placeholder="جستجوی کالا" />
      <IconButton className={classes.icon}>
        <RonadIcons name='magnifier' size={0.7} className='text-white'/>
      </IconButton>
    </div>
  )
}

export default SearchBox